<template>
  <div>
    <!-- 景区管理 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>Boss管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片开始 -->
    <el-card class="conentBox">
      <el-row class="conentRow">
        <el-col :span="24" class="scenicBtn">
          <el-button type="primary" plain @click="editFn()">
            <i class="iconfont icon-jiahao"></i>
            添加管理员
          </el-button>
        </el-col>
      </el-row>
      <el-table
        :data="bossTable"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        style="width: 100%"
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column prop="UserName" label="用户名"></el-table-column>
        <el-table-column prop="rule_name" label="所属角色"></el-table-column>
        <el-table-column prop="Phone" label="电话号码"></el-table-column>
        <el-table-column prop="E_mail" label="Email"></el-table-column>
        <el-table-column prop="address" label="操作">
          <template slot-scope="scope">
            <el-button class="editCol" type="text" @click="delFn(scope.row)">删除</el-button>
            <el-button type="text" @click="rightFn(scope.row)">权限设置</el-button>
            <el-button type="text" @click="editFn(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <!-- <el-pagination
          @current-change="handleCurrentChange"
          :current-page="bossPar.page"
          :page-size="8"
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{bossPar.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="total" :current-page="bossPar.page"  @current-change="handleCurrentChange" ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <!-- 卡片结束 -->

    <!-- 添加管理员弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="titleType"
      :visible.sync="editDialogVisible"
      :before-close="editHandleClose"
      width="33%"
      center
      class="autorDialog"
    >
      <el-divider></el-divider>
      <el-form class="editForm" ref="form" label-width="88px" :model="editData">
        <el-form-item label="用户名:">
          <span class="absPosiA">*</span>
          <el-input v-model="editData.UserName" :disabled="titleType=='修改管理员'?true:false"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名:">
          <span class="absPosiB">*</span>
          <el-input v-model="editData.realName"></el-input>
        </el-form-item>
        <!-- <el-form-item label="岗位:">
          <el-input v-model="editData.post"></el-input>
        </el-form-item>-->
        <el-form-item label="密码:">
          <span class="absPosiD">*</span>
          <el-input type="password" v-model="editData.passWord"></el-input>
        </el-form-item>
        <el-form-item label="确认密码:">
          <span class="absPosiE">*</span>
          <el-input type="password" v-model="editData.surePassWord"></el-input>
        </el-form-item>
        <el-form-item label="手机号:">
          <span class="absPosiA">*</span>
          <el-input v-model="editData.mobile"></el-input>
        </el-form-item>
        <el-form-item label="Email:">
          <span class="absPosiF">*</span>
          <el-input v-model="editData.email"></el-input>
        </el-form-item>
        <el-form-item label="所属角色:">
          <span class="absPosiG">*</span>
          <div class="flexDis itemSele">
            <el-select v-model="editData.belongRole" placeholder="请选择" disabled>
              <el-option
                v-for="item in selectData"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>

        <el-form-item class="itemBtnS" style="margin-left:-50px">
          <el-button @click="cancleFn">清空</el-button>
          <el-button class="btnL" @click="sureFn">确认保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 添加管理员弹框结束 -->
    <!-- 权限设置开始 -->
    <el-dialog :close-on-click-modal="false"
      title="管理员权限"
      :visible.sync="rightDialogVisible"
      :before-close="rightHandleClose"
      width="1082px"
      center
      class="autorDialog"
    >
      <el-divider></el-divider>
      <div class="rightBox">
        <div class="txt">
          <span>{{name}}</span>
          <span>BOSS</span>
        </div>
        <div class="rowDiv">
          <el-row class="rowCheck">
            <el-input placeholder="名称" v-model="data1.name"></el-input>
            <el-button @click="BtnsName">查询</el-button>
          </el-row>
        </div>
        <div class="contentC">
          <div class="contentleft" @scroll.passive="getScroll($event)">
            <el-checkbox-group v-model="checkedScenic">
              <el-checkbox v-for="v in cityOptions" :label="v.id" :key="v.id">{{v.name}}</el-checkbox>
            </el-checkbox-group>
            <span class="pations_data" v-if="scopeFlow">无更多数据</span>
          </div>
          <div class="contentRight">
            <el-checkbox-group v-model="checkedRight">
              <el-checkbox v-for="v in rightOption" :label="v.ScenicID" :key="v.ScenicID">{{v.Name}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="btn">
          <el-button class="btnL" @click="sureRightFn">确认添加</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 权限设置结束 -->
    <!-- 审核提交弹框开始 -->
    <!-- <el-dialog :close-on-click-modal="false"
      class="passDialog"
      :visible.sync="passDialogVisible"
      :before-close="passHandleClose"
      width="21%"
      center
      top="35vh"
    >
      <div class="passImg">
        <img style="width:128px;height:128px;" :src="imgUrl" alt />
      </div>
      <div class="passSucc">提交失败</div>
    </el-dialog>-->
    <!-- 审核提交弹框结束 -->
  </div>
</template>

<script>
import {
  getAdminUserInfoPost,
  getJfyRuleListPost,
  updateAdminUserInfoPost,
  addAdminUserInfoPost,
  adminUserInfoDeletePost,
  getScenicListPost,
  bossAddPermissionPost,
  bossPowerPermissionList,
  getBossScenicList
} from "@/request/set.js";
import { getBossListPost } from "@/request/set.js";
import { MessageBox,Message } from 'element-ui'

// const cityOptions = [];
export default {
  data() {
    const generateData = _ => {
      const data = [];
      for (let i = 1; i <= 15; i++) {
        data.push({
          key: i,
          label: `备选项 ${i}`,
          disabled: i % 4 === 0
        });
      }
      return data;
    };
    return {
      checkedCities: ["上海", "北京"],
      cityOptions: [],
      rightOption: [],
      data: generateData(),
      cityOptionsData: [],
      checkedRight: [], // 选中景区
      checkedScenic: [], // 权限添加
      value: [1, 4],
      value1: [],
      titleType: "", // 添加修改区别
      editDialogVisible: false, // 添加管理员弹框
      passDialogVisible: false, // 提交失败弹框
      rightDialogVisible: false, // 权限设置弹框
      // boss传参
      bossPar: {
        token: "",
        page: 1,
        page_size:10
      },
      bossTable: [], // 表格数据
      total: 1,
      // 修改绑定数据
      editData: {
        UserName: "", // 用户名
        realName: "", // 真是姓名
        mobile: "", // 手机号
        // post: "", // 岗位
        passWord: "", // 密码
        surePassWord: "", // 确认密码
        email: "", // Email
        belongRole: 20 // 所属角色
      },
      // 修改获取数据传参
      editPar: {
        UserID: "",
        token: ""
      },
      // 修改确认传参
      editSurePar: {
        token: "",
        UserID: "", // 管理员id
        user_name: "", // 用户名
        RoleID: "", // 角色id
        Phone: "", // 手机号
        E_mail: "", // E_mail
        pwd: "", // 密码
        confirm_pwd: "", // 确认密码
        Phone: "" // 手机号
      },
      selectData: [], // 下拉列表数据
      userId: "", // 存储管理员id
      total: 1,
      imgXl: require("@/images/scenics/sj.png"),
      imgXlb: require("@/images/scenics/sjh.png"),
      imgUrl: require("@/images/scenics/sqp.png"),
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      value: "",
      name:'',
      radio: "",
      // 工作台选项
      checkedWorde: 1, // 工作台选中
      data1:{
        token: window.sessionStorage.getItem("Token"),
        userid:'',
        name:'',
        page:1,
        page_size:10
      },
      scrollTimer :'',
      totals:0,
      scopeFlow:false
    };
  },
  mounted() {
    this.Token = window.sessionStorage.getItem("Token");
    this.bossPar = {
      token: this.Token,
      page: 1,
      page_size: 8
    };
    this.getList(this.bossPar);
  },
  methods: {
    getScroll(event){
      clearTimeout(this.scrollTimer)
      this.scrollTimer = setTimeout(()=>{
          let scrollBottom =
          event.target.scrollHeight -
          event.target.scrollTop -
          event.target.clientHeight;
          let pSize = this.data1.page
          let pNum = this.data1.page_size
          if (scrollBottom < 40) {
            if(pNum*pSize>=this.totals){
                this.scopeFlow = true
            }else{
              this.data1.page +=1
              this.getScenic()
            }
          }
      },300)
      
    },
    // 获取列表数据
    getList(data) {
      getBossListPost(data).then(res => {
        this.bossPar.page = res.data.result.current_page
        this.bossTable = res.data.result.data;
        this.total = res.data.result.total;
      });
    },
    // 获取所属角色下拉框值
    getSelect() {
      let upData = {
        token: this.Token
      };
      getJfyRuleListPost(upData).then(res => {
        this.selectData = res.data.result.data;
      });
    },
    BtnsName(){
      this.data1.page = 1
      this.totals = 0
      this.cityOptions = []
      this.cityOptionsData = []
      this.getScenic()
    },
    // 获取权限设置所有景区
    getScenic() {
      getBossScenicList(this.data1).then(res => {
       if(res.data.status=='ok'){
          this.totals = res.data.result.total
          let repon = res.data.result.data
          this.cityOptionsData = this.cityOptionsData.concat(repon);
          this.cityOptions = []
          this.cityOptionsData.map((item, index) => {
            this.cityOptions.push({ name: item.Name, id: item.ScenicID });
          });
       }
      });
    },
    // 点击权限设置
    rightFn(row) {
      this.name = row.UserName
      this.userId = row.UserID;
      this.data1.userid = row.UserID
      this.rightDialogVisible = true;
      this.getScenic();
      let data = {
        UserID:row.UserID,
        token:window.sessionStorage.getItem("Token")
      }
      bossPowerPermissionList(data).then(res=>{
        if(res.data.status=='ok'){
          this.rightOption = res.data.result
          this.rightOption.map(item=>{
            this.checkedRight.push(item.ScenicID)
          })
        }
      })
    },
    // 点击权限设置关闭X
    rightHandleClose() {
      this.cityOptions = []  
      this.cityOptionsData = []
      this.rightOption = []
      this.data1.name  = ''
      this.data1.page = 1
      this.total = 0
      this.rightDialogVisible = false;
    },

    // 修改清空
    cancleFn() {
      this.editData={
        UserName: this.editData.UserName, // 用户名
        realName: "", // 真是姓名
        mobile: "", // 手机号
        // post: "", // 岗位
        passWord: "", // 密码
        surePassWord: "", // 确认密码
        email: "", // Email
        belongRole: 20 // 所属角色
      }
    },
    // 点击确认保存
    sureFn() {
      console.log(this.editData.passWord&&this.editData.surePassWord)
      if(this.editData.passWord&&this.editData.surePassWord){
        if(this.editData.passWord!=this.editData.surePassWord){
            Message.error('两次密码不一致')
            return false
          }
      }
      if (this.userId) {
        // 修改
        console.log("修改");
        this.editSurePar = {
          token: this.Token,
          UserID: this.userId, // 管理员id
          user_name: this.editData.UserName, // 用户名
          name: this.editData.realName, // 真实姓名
          RoleID: this.editData.belongRole, // 角色id
          Phone: this.editData.mobile, // 手机号
          E_mail: this.editData.email, // E_mail
          pwd: this.editData.passWord, // 密码
          confirm_pwd: this.editData.surePassWord // 确认密码
        };
        updateAdminUserInfoPost(this.editSurePar).then(res => {
          if (res.data.rcode == 200) {
            Message.success(res.data.msg);
            this.editDialogVisible = false;
            let data  = {
              token: this.Token,
            };
            this.getList(data);
          } else {
            Message.error(res.data.msg);
          }
        });
      } else {
        // 添加
        console.log("添加");
        this.editSurePar = {
          token: this.Token,
          // UserID: this.userId, // 管理员id
          user_name: this.editData.UserName, // 用户名
          name: this.editData.realName, // 真实姓名
          RoleID: this.editData.belongRole, // 角色id
          Phone: this.editData.mobile, // 角色id
          E_mail: this.editData.email, // E_mail
          pwd: this.editData.passWord, // 密码
          confirm_pwd: this.editData.surePassWord // 确认密码
        };
        addAdminUserInfoPost(this.editSurePar).then(res => {
          if (res.data.rcode == 200) {
            Message.success(res.data.msg);
            this.editDialogVisible = false;
            this.bossPar = {
              token: this.Token,
              page: 1,
              page_size:10
            };
            this.total = 0
            this.getList(this.bossPar);
          } else {
            Message.error(res.data.msg);
          }
        });
      }
      // this.passDialogVisible = true;
    },
    // 提交失败
    passHandleClose() {
      this.passDialogVisible = false;
    },
    // 删除
    delFn(row) {
      let upData = {
        UserID: row.UserID,
        token: this.Token
      };
      MessageBox("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          adminUserInfoDeletePost(upData).then(res => {
  
            if (res.data.rcode == 200) {
              Message({
                type: "success",
                message: res.data.msg
              });
              this.bossPar = {
                token: this.Token,
                page: 1,
                page_size:10
              };
              this.total = 0
              this.getList(this.bossPar);
            }
          });
        })
        .catch(() => {
          Message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 添加修改管理员
    editFn(row) {
      if (row) {
        // 修改
        this.titleType = "修改管理员";
        this.editPar = {
          UserID: row.UserID,
          token: this.Token
        };
        this.userId = row.UserID;
        this.getSelect();
        getAdminUserInfoPost(this.editPar).then(res => {
          this.editData = {
            UserName: res.data.result.UserName, // 用户名
            realName: res.data.result.Name, // 真是姓名
            mobile: res.data.result.Phone, // 手机号
            // post: res.data.result.UserName, // 岗位
            passWord: "", // 密码
            surePassWord: "", // 确认密码
            email: res.data.result.E_mail, // Email
            belongRole: res.data.result.RoleID // 所属角色
          };
        });
      } else {
        // 添加
        this.titleType = "添加管理员";
        // 初始化数据
        this.editData = {
          UserName: "", // 用户名
          realName: "", // 真是姓名
          mobile: "", // 手机号
          // post: "", // 岗位
          passWord: "", // 密码
          surePassWord: "", // 确认密码
          email: "", // Email
          belongRole: 20 // 所属角色
        };
        this.getSelect();
      }
      this.editDialogVisible = true;
    },
    // 权限设置确认
    sureRightFn() {
      console.log(this.checkedScenic.toString(),this.checkedRight.toString())
      let ids = this.checkedScenic.toString() +','+ this.checkedRight.toString()
      var id = ''
      if(ids[0]==','){
        id = ids.slice(1)
      }else{
        id = ids
      }
      let upData = {
        token: this.Token,
        UserID: this.userId,
        ScenicID: id
      }
      bossAddPermissionPost(upData).then(res => {
        if (res.data.rcode == 200) {
          this.getList(this.bossPar);
          this.rightDialogVisible = false
          this.checkedScenic = []
          this.checkedRight = []
          this.cityOptions  =[]
          this.cityOptionsData = []
          this.rightOption = []
          this.data1.page = 1
          this.data1.name  = ''
          this.total = 0
          Message.success(res.data.msg);
        } else {
          Message.error(res.data.msg);
        }
      });
    },
    // 添加管理员弹框X
    editHandleClose() {
      this.editDialogVisible = false;
    },
    // 分页
    handleCurrentChange(val) {
      this.bossPar.page = val;
      this.getList(this.bossPar);
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang="less" scoped>
.rightBox {
  .btn {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    .el-button {
      width: 100px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      background: #246deb;
      border-radius: 4px;
      border: none;
    }
  }
  .txt{
    span{
      color: #666;
      font-size: 1.4rem;
      &:nth-child(1){
        font-family: OPPOSans;
        margin-right: 1rem;
        color: #000000;
      }
    }
  }
  .contentC {
    width: 100%;
    height: 343px;
    display: flex;
    margin: 20px 0 42px 0px;
    /dee/.el-checkbox-group {
      display: flex;
    }
    /deep/.el-checkbox {
      width: 305px;
      margin: 16px 0;
      display: block;
      line-height: 23px;
      white-space: normal;
      margin-right: 0;
      text-align: left;
    }
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #4ecb73;
      border-color: #4ecb73;
    }
    /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */
      color: #666666;
    }
    .contentleft {
      width: 30rem;
      height: 100%;
      margin-right: 20px;
      padding: 20px;
      box-sizing: border-box;
      overflow-y: scroll;
      background: #ffffff;
      border: 1px solid #e5e5ea;
      border-radius: 4px;

    }
    .contentRight {
      flex: 1;
      height: 100%;
      background: #ffffff;
      border: 1px solid #e5e5ea;
      border-radius: 4px;
      padding: 20px;
      box-sizing: border-box;
      overflow: scroll;
      /deep/.el-checkbox-group {
        display: flex;
        flex-wrap: wrap;
      }
    }
  }
  .rowDiv {
    // display: flex;
    //   width: 100%;
    // justify-content: flex-end;
    .rowCheck {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      .el-input {
        width: 400px;
        height: 40px;
        margin-right: 20px;
      }
      .el-button {
        width: 100px;
        height: 40px;
        background: #006afa;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        border: none;
      }
    }
  }
}
.el-form-item {
  position: relative;
}
.absPosiA {
  position: absolute;
  top: 0px;
  left: -65px;
  color: #ff4d4f;
}
.absPosiB {
  position: absolute;
  top: 0px;
  left: -78px;
  color: #ff4d4f;
}
.absPosiD {
  position: absolute;
  top: 0px;
  left: -51px;
  color: #ff4d4f;
}
.absPosiE {
  position: absolute;
  top: 0px;
  left: -78px;
  color: #ff4d4f;
}
.absPosiF {
  position: absolute;
  top: 0px;
  left: -58px;
  color: #ff4d4f;
}
.absPosiG {
  position: absolute;
  top: 0px;
  left: -78px;
  color: #ff4d4f;
}
.rightSet {
  .rightWorke {
    > div:nth-child(1) {
      margin-bottom: 7px;
      > span:nth-child(1) {
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */
        text-align: center;
        color: #000000;
        margin-right: 10px;
      }
    }
    .itemWorke {
      margin-bottom: 17px;
      > div:nth-child(1) {
        display: flex;
        justify-content: space-between;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */
        color: #666666;
        margin-bottom: 5px;
      }
      > div:nth-child(2) {
        background: #ffffff;
        border: 1px solid #e5e5ea;
        border-radius: 4px;
        padding: 20px;
        height: 44px;
        /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #4ecb73;
          border-color: #4ecb73;
        }
        /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          /* identical to box height */
          color: #666666;
        }
      }
    }
  }
}
.passDialog {
  // /deep/.el-dialog__header{
  //   height: 0;
  // }
  .passImg {
    display: flex;
    justify-content: center;
    align-items: center;
    // margin-top: 58px;
    margin-bottom: 33px;
  }
  .passSucc {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    /* identical to box height */
    color: #000000;
    margin-bottom: 30px;
  }
}
.editForm {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  /deep/.el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #666666;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }
  .itemBtnS {
    display: flex;
    justify-content: center;
    margin-top: 42px;
    margin-left: -88px;
    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      height: 40px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }

  .el-form-item {
    margin-bottom: 20px;
  }
  .itemSele {
    // width: 500px;
    height: 40px;
    /deep/.el-select {
      width: 100%;
      height: 100%;
    }
  }
}

.el-form-item {
  position: relative;
}
// .absPosiA {
//   position: absolute;
//   top: 0px;
//   left: -78px;
//   color: #ff4d4f;
// }

.editCol {
  color: #ff4d4f;
}
.conentBox {
  margin-top: 17px;
  height: 740px;
  .conentRow {
    margin-bottom: 20px;
  }
}
.scenicBtn {
  height: 40px;
  display: flex;
  justify-content: flex-end;
  // margin-left: 42px;
  .el-button {
    width: 120px;
    display: flex;
    justify-content: center;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #246deb;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
  }
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}

// 弹框
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}

/deep/ .el-dialog{
  min-width: 400px;
}
.contentleft /deep/ .el-checkbox{
  width: 100% !important;
  display: flex !important;
}
.pations_data{
  width: 100%;
    display: block;
    text-align: center;
    color: red;
    font-size: 16px;
}
</style>